/* unplugin-vue-components disabled */import script from "./SmallLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmallLoading.vue?vue&type=script&setup=true&lang=ts"

import "./SmallLoading.vue?vue&type=style&index=0&id=77df69d4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77df69d4"]])

export default __exports__